@if (isCheckBox) {
  <app-button
    [title]="selectedOrgUuids.length + ' organization' + (selectedOrgUuids.length === 1 ? '' : 's')"
    [type]="buttonType"
    [showIcon]="'right'"
    [size]="'xsmall'"
    [additionalClasses]="additionalClass"
    [iconName]="'white-arrow-down.svg'"
    (click)="showOrgMenu=true">
    {{selectedOrgUuids.length}} organization{{selectedOrgUuids.length === 1 ? '' : 's'}}
  </app-button>

  @if (showOrgMenu) {
    <app-popup-modal (closeModal)="showOrgMenu = false">
      <div class="checkbox-dropdown-body">
        <div
          data-qa="bdd-select-all"
          class="start-row-container upper-text-button font-3 bold500"
          (click)="$event.stopPropagation(); toggleSelectAll()">
          {{allSelected ? 'Unselect all' : 'Select all'}}
        </div>
        <div
          data-qa="bdd-select-current-org"
          class="start-row-container upper-text-button font-3 bold500"
          (click)="$event.stopPropagation(); selectCurrentOrg()">
          Current organization
        </div>
        <div
          *ngFor="let element of data; let i = index"
          class="start-row-container row-gap-0p5"
          (click)="$event.stopPropagation(); selectOne(i)">
          <app-checkbox class="no-propagation" [checked]="element.selected"></app-checkbox>
          <span class="font-3 bold500">{{element[field]}}</span>
        </div>
      </div>
    </app-popup-modal>
  }

} @else {
  <div class="picker min-width-6p5">
    <div
      *ngIf="showDoubleButton"
      data-qa="double-button"
      class="centered-row-container row-gap-0p1 double-button"
      (click)="isDropdownOpen = true" >
      <app-button
        data-qa="left-button"
        [size]="size"
        [type]="buttonType"
        [disabled]="disabled"
        [showIcon]="'left'"
        [bordersSquaredShape]="'right'"
        [additionalClasses]="additionalClass"
        [iconName]="icon"
        (buttonClick)="leftButtonClickEmitter.emit()">
        {{displayedItem}}
      </app-button>
      <app-button
        data-qa="right-button"
        class="flex00auto"
        [size]="'small'"
        [type]="buttonType"
        [disabled]="disabled"
        [bordersSquaredShape]="'left'"
        [showIcon]="'only'"
        [iconName]="'arrow-down.svg'"
      />

      <div *ngIf="!disabled" class="picker-dropdown {{dropDownWidth}} centered-column-container {{reverse ? 'dropdown-reverse' : ''}}" >
        <div class="picker-list centered-column-container">
          <div class="vertical-container-simple column-gap-0p3125 width-100pcnt">
            @if (simpleData?.length) {
              <span *ngFor="let item of simpleData; let i = index"
                    class="table-menu-item"
                    [attr.data-qa]="'item-' + i"
                    (click)="itemEmitter.emit(item)">
                <app-all-icons *ngIf="showDropDownIcons"
                               [iconNameAndStyling]="dropDownIconNameAndStyling">
                </app-all-icons>
                <span class="table-menu-text'">{{item}}</span>
              </span>
            } @else {
              <span *ngFor="let item of data; let i = index"
                    class="table-menu-item {{item?.nameStyling}}"
                    [attr.data-qa]="'item-' + i"
                    (click)="itemEmitter.emit(item)" >
                <app-all-icons *ngIf="showDropDownIcons" class="picker-icon"
                               [iconNameAndStyling]="item.iconAndStyling">
                </app-all-icons>
                <span class="table-menu-text'">
                  {{item[field]}}
                </span>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="picker">
    <app-button
      *ngIf="!showDoubleButton"
      data-qa="notifications-shared-personal"
      [size]="size"
      [type]="buttonType"
      [showIcon]="showIcon"
      [additionalClasses]="additionalClass"
      [iconName]="'white-arrow-down.svg'">
      {{displayedItem}}
    </app-button>
    <div class="picker-dropdown {{dropDownWidth}} centered-column-container">
      <div class="picker-list centered-column-container">
        <div class="align-self-stretch width-100pcnt">
        <span *ngFor="let item of simpleData; let i = index" class="table-menu-item"
              data-qa="list + '-' + i"
              (click)="itemEmitter.emit(item)" >
        <app-all-icons *ngIf="showDropDownIcons"
                       [iconNameAndStyling]="dropDownIconNameAndStyling">
        </app-all-icons>
        <span class="font-4">
          {{item}}
        </span>
      </span>
        </div>
      </div>
    </div>
  </div>
}
